export default __webpack_public_path__ + "static/media/CHANGELOG.a72bd2e1.md";